import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import { STREAM_CHANNELS_PATHS } from './constants';

const StreamingChannels = () => {
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.Channel,
  });

  return (
    <div className="grid grid-cols-4 items-center gap-x-40 gap-y-20 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4">
      {STREAM_CHANNELS_PATHS.map((channel) => (
        <a
          key={channel.name}
          href={channel.url}
          className="group block w-min self-center leading-none transition-colors"
          onClickCapture={() =>
            trackEvent(click({ clickTarget: ClickTarget.Link, clickText: channel.name }))
          }
          rel="noreferrer"
          target="_blank"
          aria-label={`Stream TITV on ${channel.name}`}
        >
          <div className="block">{channel.icon}</div>
        </a>
      ))}
    </div>
  );
};

export default StreamingChannels;
